import React, { PropsWithChildren } from "react";
import cx from "classnames";
import EditButton from "pages/Profile/components/common/EditButton";
import "./styles.scss";

interface Props {
  className?: string;
  iconClassName?: string;
  isEdit?: boolean;
  editBottom?: boolean;
  isLoading?: boolean;
  onClickEdit?: () => void;
  editToPath?: string;
}

const ProfileCard = ({
  children,
  isEdit,
  isLoading,
  editBottom,
  onClickEdit,
  editToPath,
  className,
  iconClassName,
}: PropsWithChildren<Props>) => (
  <div className={cx("profile-card", { loading: isLoading }, className)}>
    {isEdit && !isLoading && (
      <EditButton
        onClick={onClickEdit}
        editToPath={editToPath}
        className={cx("card-edit", {
          "card-edit--top": !editBottom,
          "card-edit--bottom": editBottom,
        })}
        iconClassName={iconClassName}
      />
    )}
    {children}
  </div>
);

export default ProfileCard;
